import { batteryPricingBundle } from "./battery-pricing-bundle"
import { PricingVppProgramsStep } from "../../ProposalSetup/pricing/PricingVppProgramsStep"

export { VPP_NO_ELIGIBLE_PROGRAMS } from "./battery-pricing-bundle"
export {
  VPP_LOAD_FAILED,
  VPP_SAVE_FAILED,
} from "../../ProposalSetup/pricing/PricingVppProgramsStep"

export const VppProgramsStep = ({
  proposalId,
  onClose,
}: {
  proposalId: string
  onClose: () => void
}): JSX.Element => (
  <PricingVppProgramsStep
    kind={batteryPricingBundle}
    proposalId={proposalId}
    onClose={onClose}
  />
)
